import { FEATURE_FLAGS } from '@api/queries/featureFlag';
import { useLazyQuery } from '@apollo/client';
// import AsyncStorage from '@react-native-async-storage/async-storage';
import { getStore } from '@store/storeUtils';
import {
  isFeatureEnabled,
  // , serverError
} from '@utils/utils';
import { useEffect, useMemo } from 'react';
// import {
//   setFeatureFlag,
//   setFeatureFlagError,
//   setFeatureFlagLoading,
// } from '@gaji-gesa/gg-react-shared/src/redux/action/FeatureFlags';

// import { useNavigation } from '@react-navigation/native';
// import { useToast } from 'native-base';
import { featureFlagOnComplete, featureFlagOnError } from './customHookUtils';
// import { isFeatureEnabled } from '@gaji-gesa/gg-react-shared/src/utils/sharedUtils';

const useFeatureFlag = ({ featureName, onCompleted, onCompleteWithDynamicFeature }) => {
  // const { featureFlags, error, loading } = useSelector(state => state.FeatureFlag);
  // const { employerId } = useSelector(state => state.Authentication);
  // const dispatch = useDispatch();
  const { featureFlags, setFeatureFlags, employerId } = getStore();
  // const navigation = useNavigation();
  // const toast = useToast();
  const [getFeatureFlags] = useLazyQuery(FEATURE_FLAGS, {
    fetchPolicy: 'no-cache',
    variables: { employerId },

    onCompleted: data => {
      // dispatch(setFeatureFlag(data?.app_feature ?? [], false));
      featureFlagOnComplete(setFeatureFlags, data, onCompleted, featureName, onCompleteWithDynamicFeature);
    },
    onError: () => {
      featureFlagOnError();
    },
  });

  // useEffect(() => {
  //   if (error && !loading) {
  //     // dispatch(setFeatureFlagLoading(true));
  //     getFeatureFlags();
  //   }
  // }, [error, getFeatureFlags, loading]);

  useEffect(() => {
    getFeatureFlags();
  }, []);

  // useEffect(() => {
  //   setLoading(loading);
  // }, [loading]);

  const isFeatureAvailale = useMemo(() => isFeatureEnabled(featureFlags, featureName), [featureFlags, featureName]);

  if (featureName) {
    return [isFeatureAvailale, getFeatureFlags];
  }

  return [getFeatureFlags];
};

export default useFeatureFlag;
